import { FormattedMessage } from "react-intl"

import SBEditable from "../../../components/sbEditable/sbEditable"
import { FileToVideoMIMEType } from "../../../helpers/MIMEHelpers"
import { ArticlePanelOptionsToClasses } from "../articlePanelHelpers"

function html5videoembed({ blok }) {
  const showControls = blok.showcontrols === "yes" ? true : null

  return (
    <SBEditable blok={blok} withClass={ArticlePanelOptionsToClasses(blok)}>
      <video controls={showControls} width={blok.width} height={blok.height} style={{width: "100%", height: "auto"}}>
        {blok.sources.map((sourceBlok) => {
          return <VideoSource key={sourceBlok._uid} source={sourceBlok.source} url={sourceBlok.url} />;
        })}
        <p>
          <FormattedMessage id="component.articlepanels.html5videoembed.unsupported_message" />
        </p>
      </video>
    </SBEditable>
  )
}

function VideoSource({ source, url }) {
  let videoSrc = '';
  if (source && source.filename) {
    videoSrc = source.filename;
  } else if (url) {
    videoSrc = url;
  }
  return <source src={videoSrc} type={FileToVideoMIMEType(videoSrc)} />
}

export default html5videoembed